import PropTypes from 'prop-types';

import MDBox from 'components/MDBox';
import PageLayout from 'components/LayoutContainers/PageLayout';
import Footer from 'pages/authentication/components/Footer';

export default function PublicLayout({ title, footerDisplayed = true, children }) {
  return (
    <PageLayout title={title}>
      <MDBox
        width="100%"
        minHeight="100vh"
        sx={{
          display: 'flex'
        }}
      >
        {children}
      </MDBox>
      {footerDisplayed && <Footer light />}
    </PageLayout>
  );
}

PublicLayout.propTypes = {
  title: PropTypes.string,
  footerDisplayed: PropTypes.bool,
  children: PropTypes.node.isRequired
};
